import request from '@/utils/request'

export function insertBookingApi(data) {
  return request({
    url: '/booking-service/v1/booking/insert',
    method: 'post',
    data: data
  })
}

export function generateDailyPriceApi(dateFrom, dateTo, roomLevelId, isBf) {
  return request({
    url: '/booking-service/v1/booking/generate-daily-price',
    method: 'get',
    params: {
      dateFrom,
      dateTo,
      roomLevelId,
      isBf
    }
  })
}

export function getRoomBookingDailyPrice(id) {
  return request({
    url: `/booking-service/v1/booking/${id}/detail-price`,
    method: 'get'
  })
}

export function updateRoomBooking(id, payload) {
  return request({
    url: `/booking-service/v1/booking/update-room-booking/${id}`,
    method: 'put',
    data: payload
  })
}

export function getBookingRoomSpecialService(id) {
  return request({
    url: `/booking-service/v1/booking/${id}/special-service`,
    method: 'get'
  })
}

export function getBookingRoom(id) {
  return request({
    url: `/booking-service/v1/booking/room-booking/${id}`,
    method: 'get'
  })
}

export function updateBookingRoom(id, payload) {
  return request({
    url: `/booking-service/v1/booking/update-room-booking/${id}`,
    method: 'put',
    data: payload
  })
}

export function getIdImageApi(payload) {
  return request({
    url: `/booking-service/v1/booking/img-certification`,
    method: 'get',
    params: payload
  })
}
